<script>
	import "./api";
	import { setupCache, setupFeed } from "./api";
	setupCache()
	import Map from "./Map.svelte";
	import NavLink from "./components/NavLink.svelte";
	import { Router, Route } from "svelte-navigator";
	import Redirect from "./components/Redirect.svelte";
	import Flights from "./routes/Flights.svelte";
	import Flight from "./routes/Flight.svelte";
	import FlightNew from "./routes/FlightNew.svelte";
	import Devices from "./routes/Devices.svelte";
	import GlobalADSB from "./global/GlobalADSB.svelte";
	import GlobalFeed from "./global/GlobalFeed.svelte";
	import GlobalGRS from "./global/GlobalGRS.svelte";
  import GlobalRadar from "./global/GlobalRadar.svelte";
	import GlobalPercepto from "./global/GlobalPercepto.svelte";
	import { version, toolboxEnabled, enablePi, devModeEnabled } from "./const";
	import Measure from "./components/Measure.svelte";
	import { auth, hasRole } from "./auth";
	import Login from "./components/Login.svelte";
  import Admin from "./routes/Admin.svelte"
  import UserTopBar from "./components/UserTopBar.svelte";
  import GlobalSRS from "./global/GlobalSRS.svelte";
	import MapRoute from './routes/Map.svelte'
	import Sidebar from "./components/Sidebar.svelte"
	import BackButton from "./components/BackButton.svelte";

	let srsFilterRadioId
	let hamburgerOpen = false;

	async function getVersion() {
		try {
			const response = await fetch("/build.json");
			const build = await response.json();
			return build.version;
		} catch (error) {
			return null;
		}
	}

	function logoClicked(ev) {
		if (ev.ctrlKey) {
			enablePi.set(true);
		} else {
			toolboxEnabled.update((old) => !old);
		}
	}

	function hamburgerClicked() {
		hamburgerOpen = !hamburgerOpen;
	}

	// Start the auth process
	const authPromise = auth.getToken()
	$: if ($auth.token) {
		setupFeed()
	}
</script>

<Router>
	<div class="baseContainer">
		<nav>
			<div class="header">
				<div class="logoContainer">
					<BackButton />
					<img
					src="/images/skyline_logo.png"
					alt="SkyLine"
					height="30 px"
					on:dblclick={logoClicked}
					/>
					{#await getVersion() then buildVersion}
						<span class="version" data-tooltip={buildVersion}>{version}</span>
					{/await}

				</div>
				
				
			</div>
			{#if $auth.username !== undefined}
				<div class={`menu submenu ${hamburgerOpen ? 'mobileNav' : ''}`} on:click={hamburgerClicked}>
					<NavLink to="devices">Devices</NavLink>
					<NavLink to="flights">Flights</NavLink>
					<NavLink to="map">Map</NavLink>
					{#if hasRole($auth, 'admin')}
						<NavLink to="admin">Admin</NavLink>
					{/if}
				</div>
				<div class={`${hamburgerOpen ? 'mobileNavAuth' : 'userContainer'}`}>				
					<UserTopBar />
				</div>
				<div class="hamburgerContainer">
					<img src="/images/menu.svg" alt="Dropdown menu icon" height="30 px" on:click={hamburgerClicked} />
				</div>
			{/if}
		</nav>
		{#await authPromise then _}
			{#if !$auth.username}
				<Login />
			{:else}
				<div class="map">
					<Map />
					<Measure />
				</div>
				{#if $auth.token}
					<GlobalFeed>
						<GlobalADSB bind:filterRadioId={srsFilterRadioId} />
						<GlobalRadar />
						<GlobalPercepto />
					</GlobalFeed>
				{/if}
				<GlobalGRS />
				<GlobalSRS bind:filterRadioId={srsFilterRadioId} />
				<div class="routeContainer">
					<Route>
						<Redirect to="/flights" />
					</Route>
					<Route path="/flights">
						<Flights />
					</Route>
					<Route path="/flights/new">
						<FlightNew />
					</Route>
					<Route path="/flights/:id" primary={false} let:params>
						{#if params.id}
							<Flight id={params.id} />
						{/if}
					</Route>
					<Route path="/devices/*id" primary={false} let:params>
						<Devices selectedId={params.id} />
					</Route>
					<Route path="/map" primary={false} >
						<MapRoute />
					</Route>
					{#if hasRole($auth, 'admin')}
						<Route path="/admin">
							<Admin />
						</Route>
					{/if}
				</div>
			{/if}
		{/await}
		<Sidebar />
	</div>
	{#if $enablePi}
		<div
			class="pi"
			class:piEnabled={$devModeEnabled}
			on:click={() => devModeEnabled.update((dm) => !dm)}
		>
			π
		</div>
	{/if}
</Router>

<style>
	.baseContainer {
		display: grid;
		grid-template-rows: auto minmax(0, 1fr);
		grid-template-columns: minmax(0, 1fr) auto;
		height: 100%;
	}

	.routeContainer {
		height: 100%;
		grid-row: 2;
		grid-column: 1;
		z-index: 10;
		pointer-events: none;
		display: grid;
		grid-template-rows: minmax(0, 1fr);
		grid-auto-rows: auto;
		position:relative;
	}

	:global(.routeContainer > *) {
		grid-row: 1;
		grid-column: 1;
		pointer-events: auto;
	}

	.map {
		height: 100%;
		grid-column: 1;
		grid-row: 2;
	}

	/** Nav bar **/
	nav {
		background-color: black;
		color: white;
		display: flex;
		justify-content: space-between;
		align-items: stretch;
		height: 40px;
		grid-column: 1 / -1;
		grid-row: 1;
	}

	nav div.menu {
		font-size: 10pt;
		display: flex;
		padding: 0;
		margin: 0;
		margin-top: 1rem;
		align-items: flex-end;
	}

	:global(nav div.menu a) {
		margin: 0;
		padding: 0;
		padding: 0 4rem 0 4rem;
		font-style: normal;
		text-decoration: none;
		color: inherit;
		height: 26px;
	}

	:global(nav div.menu a:hover) {
		border-bottom: 2px solid rgb(165, 165, 165);
	}

	:global(nav div a.active) {
		border-bottom: 2px solid white;
	}
	nav div {
		/* display: flex;
		align-items: center;
		gap: 4px; */
	}

	.logoContainer {
		display: flex;
    align-items: flex-end;
		padding: 5px 8px;
	}

	.hamburgerContainer {
		order: 2;
		display: none;
	}

	.hidden {
		display: none;
	}

	.version {
		position: relative;
	}

	.version:global([data-tooltip]::before) {
		padding: 2px;
	}

	.pi {
		position: absolute;
		left: 8px;
		bottom: 8px;
		background-color: rgb(37, 37, 37);
		color: white;
		padding: 4px;
		z-index: 1000;
		cursor: pointer;
	}

	.piEnabled {
		background-color: green;
	}
	@media only screen and (max-width: 600px) {
			nav {
        
				flex-wrap: wrap;
				height: 46px;
				position: fixed;
				left: 0;
				top: 0;
				width: 100%;
      }
			:global(nav div.menu a.active) {
				border-bottom: 2px solid white;
				background-color: #333;
			}
			nav div.menu {
				display: none;
				order: 4;
				width: 100%;
				justify-content: center;
				background-color: black;
				margin-top: 0;
				flex-direction: column;
				box-shadow: 0px 10px 6px -4px rgba(70,70,70,70.75);
			}

			:global(nav div.menu a) {
				width: 100%;
				text-align: center;
				height: 48px;
				align-self:center;
				padding-top:16px;
			}

			.mobileNav {
				display: flex !important;
			}

			


			.hamburgerContainer {
				display: flex;
				margin: 8px
			}

			.userContainer {
				display: none;
			}

			.mobileNavAuth {
				display: block;
				order: 3;
			}

	}
</style>
